import "./LevelsCollapseHeader.less"

import { useGeneralContext } from "@/components/context/GeneralContext"
import { SvgIcon } from "@/components/icon"
import { LevelItem } from "@/components/modal-dark/modal-dark-platform-content/level-of-service/WayleaveRequirementsLevel"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Button } from "antd"
import { Dispatch, FC, SetStateAction } from "react"

const { Paragraph } = WebsiteTypography

type Props = {
  level: LevelItem
  isChecked?: boolean
  setCheckedPanelId: Dispatch<SetStateAction<EnumProjectLevelofservices>>
  isOpened: EnumProjectLevelofservices[]
}

const LevelsCollapseHeader: FC<Props> = ({ level, isChecked, setCheckedPanelId, isOpened }) => {
  const { setCurrentLevelOfService } = useGeneralContext()

  const handleOnClick = () => {
    setCheckedPanelId(level.id)
    setCurrentLevelOfService(level.id)
  }

  return (
    <div className={"levels-collapse-wrapper"}>
      <div className={"levels-collapse-img-wrapper"}>
        <img src={level.image} alt={"icon of licence level"} />
      </div>

      <div className={isOpened.includes(level.id) ? "levels-collapse-content opened" : "levels-collapse-content"}>
        <Button className={"panel-checkbox-button"} onClick={handleOnClick}>
          <div className={isChecked ? "checkbox-tick-wrapper checked" : "checkbox-tick-wrapper"}>
            {isChecked ? <SvgIcon type={"green-ticked"} /> : " "}
          </div>
          <Paragraph style={{ flex: 1, margin: 0 }}>{level.title}</Paragraph>
        </Button>
      </div>
    </div>
  )
}

export default LevelsCollapseHeader
